import { Vehicle, DashboardStats } from "../types";

// 차량 데이터 초기값
export const initialVehicles: Vehicle[] = [
  {
    id: "v1",
    image: "https://images.unsplash.com/photo-1583121274602-3e2820c69888?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80",
    ownerName: "김철수",
    vehicleName: "현대 아반떼",
    year: 2022,
    price: 25000000,
    registeredAt: "2023-06-15T09:30:00Z",
    tokenName: "AutoProof #1001"
  },
  {
    id: "v2",
    image: "https://images.unsplash.com/photo-1552519507-da3b142c6e3d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80",
    ownerName: "박영희",
    vehicleName: "BMW 520i",
    year: 2021,
    price: 65000000,
    registeredAt: "2023-05-22T14:15:00Z",
    tokenName: "AutoProof #1002"
  },
  {
    id: "v3",
    image: "https://images.unsplash.com/photo-1603584173870-7f23fdae1b7a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80",
    ownerName: "이민준",
    vehicleName: "기아 K5",
    year: 2023,
    price: 32000000,
    registeredAt: "2023-07-03T11:45:00Z",
    tokenName: "AutoProof #1003"
  },
  {
    id: "v4",
    image: "https://images.unsplash.com/photo-1617814076367-b759c7d7e738?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80",
    ownerName: "최지현",
    vehicleName: "테슬라 모델 3",
    year: 2022,
    price: 55000000,
    registeredAt: "2023-06-28T16:20:00Z",
    tokenName: "AutoProof #1004"
  },
  {
    id: "v5",
    image: "https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80",
    ownerName: "정다운",
    vehicleName: "벤츠 E-Class",
    year: 2021,
    price: 75000000,
    registeredAt: "2023-05-15T10:10:00Z",
    tokenName: "AutoProof #1005"
  }
];

// 새로운 차량 데이터 생성
const carBrands = ["현대", "기아", "제네시스", "BMW", "벤츠", "아우디", "폭스바겐", "테슬라", "렉서스"];
const carModels = [
  "아반떼", "소나타", "그랜저", "K3", "K5", "K8", "G70", "G80", "G90", 
  "520i", "530i", "730i", "E-Class", "S-Class", "C-Class", "A4", "A6", "A8",
  "골프", "티구안", "파사트", "모델 3", "모델 Y", "모델 S", "ES", "LS", "IS"
];
const firstNames = ["김", "이", "박", "최", "정", "강", "조", "윤", "장", "임", "한", "오", "서", "신", "권"];
const lastNames = ["준호", "민지", "지우", "지훈", "은지", "민준", "서연", "준영", "지은", "수진", "예은", "도윤", "하준", "지원", "준서"];

const carImages = [
  "https://images.unsplash.com/photo-1583121274602-3e2820c69888?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
  "https://images.unsplash.com/photo-1552519507-da3b142c6e3d?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
  "https://images.unsplash.com/photo-1603584173870-7f23fdae1b7a?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
  "https://images.unsplash.com/photo-1617814076367-b759c7d7e738?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
  "https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
  "https://images.unsplash.com/photo-1525609004556-c46c7d6cf023?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
  "https://images.unsplash.com/photo-1494976388531-d1058494cdd8?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
  "https://images.unsplash.com/photo-1542362567-b07e54358753?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
  "https://images.unsplash.com/photo-1553440569-bcc63803a83d?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
  "https://images.unsplash.com/photo-1553440569-bcc63803a83d?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80"
];

// 랜덤 차량 데이터 생성 함수
export function generateRandomVehicle(): Vehicle {
  const randBrand = carBrands[Math.floor(Math.random() * carBrands.length)];
  const randModel = carModels[Math.floor(Math.random() * carModels.length)];
  const randFirstName = firstNames[Math.floor(Math.random() * firstNames.length)];
  const randLastName = lastNames[Math.floor(Math.random() * lastNames.length)];
  const randYear = Math.floor(Math.random() * 5) + 2019; // 2019-2023
  const randPrice = (Math.floor(Math.random() * 80) + 20) * 1000000; // 2천만원 ~ 1억원
  const randImage = carImages[Math.floor(Math.random() * carImages.length)];
  const tokenId = Math.floor(10000 + Math.random() * 1000);
  
  return {
    id: `v${Date.now()}`,
    image: randImage,
    ownerName: `${randFirstName}${randLastName}`,
    vehicleName: `${randBrand} ${randModel}`,
    year: randYear,
    price: randPrice,
    registeredAt: new Date().toISOString(),
    tokenName: `AutoProof #${tokenId}`
  };
}

// 초기 통계 데이터
export const initialStats: DashboardStats = {
  totalVehicles: initialVehicles.length,
  totalValue: initialVehicles.reduce((sum, vehicle) => sum + vehicle.price, 0)
}; 